(function () {
  'use strict';
  angular.module('claims')
    .component('claimHeader', {
        bindings: {
          promise: '<'
        },
        controller: [ function claimHeaderComponent() {
          var ctrl = this;

          this.$onInit = function () {
            initClaimHeader();
          };

          function initClaimHeader() {
            ctrl.running = true;
            if (ctrl.promise) {
              ctrl.promise.then(function(response) {
              ctrl.serviceUnavailable = response.serviceUnavailable;

              if(response.data && response.data.claims.length){
                ctrl.claimHeaderData = response.data.claims[0];
              }
              else {
                ctrl.claimHeaderData = undefined;
              }
              ctrl.running = false;
              }, function(rejection) {
                ctrl.running = false;
              });
            }
          }

        }],
        templateUrl: 'js/claims/claimHeader.html' + appVersion
      }
    );
})();
